import {PtrnColors, PtrnTipoAccion} from '../../patronTypes';
export interface PtrnAccionButtonPersonalizacion {
   variant?: PtrnButtonVariant;
   color?: PtrnColors;
}
enum PtrnButtonVariant {
   contained = 'contained',
   outlined = 'outlined',
   text = 'text'
}
export function getBotonPersonalizacion(tipo?: PtrnTipoAccion, color?: PtrnColors) {
   const personalizacion: PtrnAccionButtonPersonalizacion = {variant: undefined, color: undefined};
   switch (tipo) {
      case PtrnTipoAccion.positiva:
         personalizacion.color = color || PtrnColors.primary;
         personalizacion.variant = PtrnButtonVariant.contained;
         break;
      case PtrnTipoAccion.neutra:
         personalizacion.color = color || PtrnColors.primary;
         personalizacion.variant = PtrnButtonVariant.outlined;
         break;
      case PtrnTipoAccion.negativa:
         personalizacion.color = color || PtrnColors.error;
         personalizacion.variant = PtrnButtonVariant.outlined;
         break;
      case PtrnTipoAccion.opcional:
         personalizacion.color = color || PtrnColors.primary;
         personalizacion.variant = PtrnButtonVariant.text;
         break;
      
      default:
         personalizacion.color = color || PtrnColors.default;
         personalizacion.variant = PtrnButtonVariant.contained;
         break;
   }
   return personalizacion;
}
